<template>
<div>
<collapsible-panel
	panel-size="sm" 
	:always-open="quote.is_finalized == 0 || !('is_finalized' in quote)" :external-toggle="quote.is_finalized == 0">
	
	<template slot="panel">
		<h5>Quote Sections</h5>

		<panel-menu
			:menu-items="quoteSections"
			:active-item="activeSection"
			v-on:itemClick="activateSection">
		</panel-menu>

		<p class="mt-4"><a href="#" v-on:click.prevent="deleteQuote" class="text-danger">Delete Quote...</a></p>
	</template>

	<template slot="main">
		<i class="fa fa-times icon-button close-edit" v-on:click="backToList"></i>
		
		<p><a :href="'/project/'+$store.project.slug+'/change-quotes'" v-on:click.prevent="backToList">
			<i class="fa fa-arrow-left"></i>
			Back to Quotes
		</a></p>

		<div class="row">
			<div v-if="quote.is_finalized == 0" class="col-lg-6">
				<vue-form
					v-on:submit="saveQuote(false)" 
					size="sm" 
					:no-top-button="true" 
					:save-button-fixed="true"
					:working="working">

					<h3 v-if="'quote_num' in quote && quote.quote_num">Quote #Q{{$store.project.job_num}}-{{quote.quote_num}}</h3>

					<section v-if="activeSection == 'Quote Details'">
						<field
	 						label="Request ID"
							col-class="col-md-4"
							v-model="quote.request_num">
						</field>

						<field
	 						label="Work Requested"
							col-class="stacked"
							:params="{type:'richtext'}"
							v-model="quote.description">
						</field>

					</section>

					<quote-labour-section v-else-if="activeSection == 'Labour'"
						:quote-id="'id' in quote ? quote.id : null"
						:labour-quoted="quoteLabour"
						:material-labour-total="materialLabourTotal"
						:quote-labour-total="quote.quote_labour_total"
						quote-object-resource="JobChangeOrderObject"
						quote-resource="JobChangeQuote"
						v-on:modelChanged="fetchQuote"
						v-on:confirmRegen="confirmRegenSection('Labour')">
					</quote-labour-section>

					<material-section v-else-if="activeSection == 'Materials'"
						:billing-document-materials="quoteMaterials"
						:billing-document-assemblies="quoteAssemblies"
						:is-quote-section="true"
						:client-invoice-settings="clientQuoteSettings"
						:billing-document-id="'id' in quote ? quote.id : null"
						billing-document-object-resource="JobChangeOrderObject"
						v-on:materialLabourChange="materialLabourChange"
						v-on:modelChanged="fetchQuote">
					</material-section>

					<invoice-equipment-section v-else-if="activeSection == 'Equipment'"
						:invoice-equipment="quoteEquipment"
						:invoice-id="'id' in quote ? quote.id : null"
						invoice-object-resource="JobChangeOrderObject"
						v-on:modelChanged="fetchQuote">
					</invoice-equipment-section>

					<invoice-additional-charges-section v-else-if="activeSection == 'Additional Charges'"
						:invoice-additional-charges="quoteAdditionalCharges"
						:invoice-id="'id' in quote ? quote.id : null"
						invoice-object-resource="JobChangeOrderObject"
						v-on:modelChanged="fetchQuote">
					</invoice-additional-charges-section>

					<invoice-display-settings v-if="activeSection == 'Display Settings'"
						:document-settings="changeOrderDisplaySettings"
						:customer-settings="customerInvoiceSettings"
						:global-settings="globalInvoiceSettings"
						layer="document"
						:is-for-service="false"
						v-on:settingsChange="invoiceDisplaySettingsChange">
					</invoice-display-settings>

					<invoice-finalizing-section v-else-if="activeSection == 'Finalizing'"
						:invoice-details="quote"
						:is-project-change-quote="true"
						type-name="Quote"
						:hide-partial-payments="true"
						v-on:detailsChange="setQuote"
						v-on:salesTaxToggle="setQuote">
					</invoice-finalizing-section>

					<button v-if="activeSection != 'Order Items'" type="button" class="btn btn-light float-left" v-on:click="prevStep">
						<i class="fa fa-chevron-left"></i> Previous Step
					</button>

					<button v-if="activeSection != 'Finalizing'" :disabled="working" type="button" class="btn btn-light float-right" v-on:click="nextStep">
						Next Step <i class="fa fa-chevron-right"></i>
					</button>
					<div v-else class="float-right">
						<button class="btn btn-lg btn-primary float-right" v-on:click="saveQuote(true)">
							<i class="fa fa-lock"></i>
							Finalize Quote
						</button>

						<p>The quote must be finalized to move onto the delivery step</p>
					</div>

				</vue-form>
			</div>
			<div v-else class="col-lg-6">

				<invoice-delivery-section class="mt-0"
					:invoice-details="quote"
					:client-invoice-settings="clientQuoteSettings"
					:has-attached-files="false"
					:customer="customer"
					type-name="Quote"
					api-resource="JobChangeQuote"
					v-on:deFinalize="definalize">

					<template slot="top">
						<context-menu v-if="quoteSlug && quoteSlug != 'new'"
							:menu-items="contextMenuItems"
							v-on:itemClick="contextMenuClick">
						</context-menu>
					</template>

					<template slot="main">
						<field v-if="quote.quote_status == 'Accepted'" 
							label="Change order ref #"
							col-class="col-sm-5"
							v-model="changeOrderRef"
							v-on:change="saveChangeOrderRef">
						</field>
					</template>

				</invoice-delivery-section>

				<activity-log 
					:submitted-log-json="quote.submitted_log_json"
					:seen-log-json="quote.seen_log_json"
					type-name="Invoice"
					:editing-log-json="quote.editing_log_json">
				</activity-log>
			</div>
			<div class="col-lg-6">
				<h3>Quote Preview</h3>

				<pdf-js v-if="quote.slug" :url="quotePreviewSrc" :page="1"></pdf-js>
				<p v-else>Save the Quote to generate a preview</p>
			</div>
		</div>
	</template>
</collapsible-panel>

<modal-dialog :modal-visible="deleteConfirmModal.visible"
	title="Delete Project Quote"
	confirm-button-text="Yes, Delete"
	button-class="btn-outline-danger"
	v-on:closeModal="deleteConfirmModal.visible = false"
	v-on:confirm="confirmDeleteQuote">

	Are you sure you want to delete this quote?

</modal-dialog>

</div>
</template>
<script type="text/javascript">

import CollapsiblePanel from "@/layout_fragments/CollapsiblePanel"
import PanelMenu from "@/components/PanelMenu"

import VueForm from "@/components/VueForm"
import Field from "@/components/Field"
import QuoteLabourSection from "@/pages/project/services/invoicing/QuoteLabourSection"
import MaterialSection from "@/pages/project/services/invoicing/MaterialSection"
import InvoiceEquipmentSection from "@/pages/project/services/invoicing/InvoiceEquipmentSection"
import InvoiceFinalizingSection from "@/pages/project/services/invoicing/InvoiceFinalizingSection"
import InvoiceAdditionalChargesSection from "@/pages/project/services/invoicing/InvoiceAdditionalChargesSection"
import InvoiceDisplaySettings from "@/components/InvoiceDisplaySettings"

import InvoiceDeliverySection from "@/components/super_components/InvoiceDeliverySection"
import ActivityLog from "@/components/ActivityLog"
import ContextMenu from "@/layout_fragments/ContextMenu"

import ModalDialog from "@/components/ModalDialog"

import PdfJs from "@/components/PdfJs"

export default {
	name: "ProjectQuote",
	components: {
		PanelMenu,
		CollapsiblePanel,
		QuoteLabourSection,
		MaterialSection,
		InvoiceEquipmentSection,
		InvoiceFinalizingSection,
		InvoiceAdditionalChargesSection,
		InvoiceDeliverySection,
		InvoiceDisplaySettings,
		ActivityLog,
		ContextMenu,
		PdfJs,
		VueForm,
		Field,
		ModalDialog
	},
	mixins: [],
	props: ["quoteSlug"],
	data() {
		return {
			quote: {
				is_finalized: 0,
			},
			changeOrderRef: "",
			quoteAssemblies: [],
			quoteMaterials: [],
			quoteLabour: [],
			quoteEquipment: [],
			quoteAdditionalCharges: [],
			customer: {},
			materialLabourTotal: 0,
			working: false,
			activeSection: "Quote Details",
			previewRefresher: 0,
			clientQuoteSettings: {},
			deleteConfirmModal: {
				visible: false
			}
		}
	},
	watch: {
		quoteSlug() {
			if (this.quoteSlug)
				this.fetchQuote()
		},
		'$store.project'() {
			if ("customer_id" in this.$store.project)
				this.fetchCustomer()
		}
	},
	computed: {
		customerInvoiceSettings() {
			let settings = {}

			try {
				settings = JSON.parse(this.customer.settings_json)
			}
			catch (e) {}

			return settings
		},
		changeOrderDisplaySettings() {
			let settings = {}

			try {
				settings = JSON.parse(this.quote.settings_override_json)
			}
			catch (e) {}

			return settings
		},
		contextMenuItems() {
			let items = []

			let disabled = true
			if (this.quote.is_finalized == 1) 
				disabled = false

			items.push({
				icon: 'fa-lock-open',
				text: "De-finalize for Editing",
				clickFunction: "definalize",
				disabled
			})
			
			items.push({
				icon: 'fa-trash',
				text: 'Delete Quote',
				clickFunction: "deleteQuote",
				itemClass: "text-danger"
			})

			return items
		},
		quoteSections() {
			if (this.quoteSlug && this.quoteSlug != 'new') {
				return [
					"Quote Details",
					"Materials",
					"Labour",
					"Equipment",
					"Additional Charges",
					//"Attachments",
					"Display Settings",
					"Finalizing"
				]
			}
			else
				return ["Quote Details"]
		},
		quotePreviewSrc() {
			return window.apiBase+"JobChangeQuote/pdf?slug="+this.quote.slug+"&token="+this.$store.sessionToken+"&humanReadable=true"+"&v="+this.previewRefresher
		}
	},
	methods: {
		activateSection(section) {
			this.activeSection = section
		},
		backToList() {
			this.$router.push("/project/"+this.$store.project.slug+"/change-quotes")
		},
		prevStep() {
			//find index of current and minus one
			this.activeSection = this.quoteSections[this.quoteSections.indexOf(this.activeSection)-1]
		},
		nextStep() {
			let vm = this
			if (!("id" in this.quote) && this.activeSection == 'Quote Details') {
				this.saveQuote().then(response => {
					vm.$nextTick(() => {
						vm.activeSection = vm.quoteSections[vm.quoteSections.indexOf(vm.activeSection)+1]
					})
				})
			}
			else
				//find index of current and minus one
				this.activeSection = this.quoteSections[this.quoteSections.indexOf(this.activeSection)+1]
		},
		contextMenuClick(clickFunction,item) {
			if ("arg" in item)
				this[clickFunction](item.arg)
			else
				this[clickFunction]()
		},
		mapQuoteObjects(list) {
			return list.map(obj => {
				let fields = JSON.parse(obj.field_values_json)

				fields.id = obj.id
				fields.quote_id = obj.quote_id

				return fields
			})
		},
		invoiceDisplaySettingsChange(settings) {
			let vm = this

			vm.$nextTick(() => {
				let payload = {
					slug: vm.quoteSlug,
					job_id: vm.$store.project.id,
					settings_override_json: JSON.stringify(settings)
				}

				vm.clientQuoteSettings = settings

				this.postData("JobChangeQuote/save",payload).then(response => {
					if (response.success)
						vm.previewRefresher++
				})
			})
		},
		setQuote(quoteDetails) {
			this.quote = quoteDetails
			this.saveQuote()
		},
		setQuoteDisplaySettings(json_string) {

			console.log(json_string)
			try {
				this.clientQuoteSettings = JSON.parse(json_string)
			}
			catch (e) {
				this.clientQuoteSettings = {}
			}
		},
		setQuoteObjects(objs) {
			let vm = this

			//condense invoiceMaterials from duplicates
			let condensedMaterials = []
			vm.mapQuoteObjects(objs.filter(obj => obj.type == "Material")).forEach(mat => {
				let foundMatIndex = condensedMaterials.findIndex(condensedMat => "material_id" in mat && "material_id" in condensedMat && condensedMat.material_id == mat.material_id)
				
				if (foundMatIndex >= 0) {
					//found, just add qty to existing
					condensedMaterials[foundMatIndex].qty += +mat.qty

					//merge assembly parent list if exists
					if ("parentAssemblies" in condensedMaterials[foundMatIndex] && "parentAssemblies" in mat)
						condensedMaterials[foundMatIndex].parentAssemblies.concat(mat.parentAssemblies)
				}
				else
					condensedMaterials.push(mat)
			})

			vm.quoteMaterials = condensedMaterials
			vm.quoteAssemblies = vm.mapQuoteObjects(objs.filter(obj => obj.type == 'Assembly'))

			vm.quoteLabour = vm.mapQuoteObjects(objs.filter(obj => obj.type == "Labour"))
			vm.quoteEquipment = vm.mapQuoteObjects(objs.filter(obj => obj.type == "Equipment"))
			vm.quoteAdditionalCharges = vm.mapQuoteObjects(objs.filter(obj => obj.type == "Additional"))
		},
		materialLabourChange(total) {
			this.materialLabourTotal = total
		},
		definalize() {
			let vm = this

			let payload = {
				id: this.quote.id,
				is_finalized: 0
			}

			this.postData("JobChangeQuote/save",payload,true).then(response => {
				if (response.success) {
					vm.quote.is_finalized = 0
					vm.fetchQuote()
					vm.alertSuccess("Quote de-finalized");
				}
			})
		},
		saveChangeOrderRef(value) {
			let vm = this

			this.postData("JobChangeQuote/save",{id: this.quote.id,change_order_ref: this.changeOrderRef},true).then(response => {
				if (response.success)
					vm.alertSaved("Change order ref # saved")
			})
		},
		deleteQuote() {
			this.deleteConfirmModal.visible = true
		},
		confirmDeleteQuote() {
			let vm = this

			let payload = {
				id: this.quote.id
			}

			this.postData("JobChangeQuote/delete",payload,true).then(response => {
				if (response.success) {
					vm.alertSuccess("Quote deleted")
					vm.$router.push("/project/"+this.$store.project.slug+"/change-quotes")
				}
			})
		},
		saveQuote(finalize) {
			let vm = this

			let fieldsToUse = [
				"id",
				"description",
				"issue_date",
				"payment_terms",
				"attn",
				"customer_notes",
				"bottom_text",
				"request_num",
				"applied_sales_tax_json",
				"expires_in_days"	
			]

			let payload = {}

			fieldsToUse.forEach(field => {
				if (field in vm.quote)
					payload[field] = vm.quote[field]
			})

			if (payload.id == 'new')
				delete payload.id

			payload.job_id = this.$store.project.id

			if (finalize)
				payload.is_finalized = 1
			
			this.working = true

			return new Promise((resolve,reject) => {

				vm.postData("JobChangeQuote/save",payload,true).then(response => {
					vm.working = false
					if (response.success) {
						vm.alertSaved("Quote saved")

						vm.previewRefresher++

						if (finalize) {
							vm.quote.is_finalized = 1
							if (vm.activeSection == 'Finalizing')
								vm.activeSection = "Delivery"

							vm.fetchQuote()
						}

						if (!("id" in payload)) {
							window.history.pushState({},"","/project/"+vm.$store.project.slug+"/quotes/"+response.data.slug)
							vm.quote.id = response.data.record_id
							vm.$emit('slugChange',response.data.slug)
						}

						resolve(response)
					}
				})
			})
		},
		fetchCustomer() {
			let vm = this

			let params = {
				include: ["Contact"]
			}

			console.log("fetchCustomer")

			this.getJSON("Contact/find/"+vm.$store.project.customer_id,params).then(response => {
				if (response.success) {
					vm.customer = response.data

					console.log(Object.keys(vm.clientQuoteSettings).length,vm.clientQuoteSettings)

					try {

						// Customer has settings? Use them. No settings? Use company settings
						if (Object.keys(vm.clientQuoteSettings).length == 0) {
							if (vm.customer.settings_json) {
								vm.setQuoteDisplaySettings(vm.customer.settings_json)
							} else if (vm.$store.company && 'CompanySetting' in vm.$store.company) {
								vm.setQuoteDisplaySettings(vm.$store.company.CompanySetting.job_defaults_json)
							}						}
					} catch (ex) {}
				}
			})
		},
		fetchQuote() {
			let vm = this

			let params = {
				include: ["JobChangeOrderObject",{model: "JobInvoiceTask",fields:["id"]}]
			}

			this.getJSON("JobChangeQuote/find/"+this.quoteSlug,params).then(response => {
				if (response.success) {
					vm.quote = response.data
					vm.previewRefresher++

					vm.changeOrderRef = response.data.change_order_ref

					// Settings for change order exist? Use them
					if ("settings_override_json" in response.data && response.data.settings_override_json)
						vm.setQuoteDisplaySettings(response.data.settings_override_json)
					else if ("settings_json" in response.data && response.data.settings_json)
						vm.setQuoteDisplaySettings(response.data.settings_json)

					vm.setQuoteObjects(response.data.JobChangeOrderObject)

					delete vm.quote.JobChangeOrderObject
				}
			})
		}
	},
	created() {
		if (this.quoteSlug)
			this.fetchQuote()

		if ('customer_id' in this.$store.project)
			this.fetchCustomer()
	}
}
</script>

<style type="text/css" scoped>
	.close-edit {
		position: absolute;
		top: 10px;
		right: 0;
		z-index: 1;
	}

	.quote-preview {
		width: 100%;
		min-height: 600px;
		border: 1px solid #e0e0e0;

	}

	.attachment-image-thumb {
		width: 80px;
		height: 80px;
		display: inline-block;
	}

	@media (max-width: 1200px) {

		.quote-preview {
			width: 100%;
			height: calc(100% - 60px);
		}

	}
</style>